import React from 'react';

import { localDateTime } from './changeRequestFormat';

/**
 * Why the requester asked for the change, as they wrote it when submitting. Shared
 * by the read-only Budget Changes pop-up and Home's approval pop-up so both show
 * the same text. The text renders as a React child, so markup in it is escaped;
 * line breaks are kept by the block's pre-wrap.
 */
export default function RequesterExplanation({ row }) {
    const submittedAt = localDateTime(row.submitted_at);

    return (
        <div>
            <div className="bc-eyebrow">{$t("Requester's explanation")}</div>
            <div className="bc-explanation">
                <div className="tw-mb-2 tw-flex tw-flex-wrap tw-items-center tw-gap-2.5">
                    {row.requested_by_initials && (
                        <span className="bc-avatar" aria-hidden="true">
                            {row.requested_by_initials}
                        </span>
                    )}
                    <span className="tw-font-medium">{row.requested_by}</span>
                    <span className="tw-text-xs tw-text-charcoal-50">{submittedAt}</span>
                </div>
                <p className="tw-mb-0 tw-whitespace-pre-wrap tw-break-words">{row.explanation}</p>
            </div>
        </div>
    );
}
